import { PATHS } from '../../../constants/paths';

import {
  claimsMenyIcon,
  paymentsMenuIcon,
  staffMenuIcon,
  shipFromMenuIcon,
  shipmentsMenuIcon,
  dashboard,
  billingIcon,
  leaseProtectionIcon,
} from '../../../assets';

export const menuListData = [
  {
    menuName: 'Dashboard',
    link: PATHS.DASHBOARD,
    icon: dashboard,
    toShow: ["ADMIN", "STAFF", "MANAGER", "SALES"],
  },
  {
    menuName: 'Shipments',
    link: PATHS.SHIPMENTS,
    icon: shipmentsMenuIcon,
    toShow: ["ADMIN", "STAFF", "MANAGER", "SALES"],
    children: [
      {
        menuName: 'All Shipments',
        link: PATHS.SHIPMENTS,
        icon: shipmentsMenuIcon,
      },
      {
        menuName: 'Pending Shipments',
        link: PATHS.PENDING_SHIPMENTS,
        icon: shipmentsMenuIcon,
      },
      // {
      //   menuName: 'Canceled Shipments',
      //   link: PATHS.CANCEL_SHIPMENTS,
      //   icon: shipmentsMenuIcon,
      // },
    ],
  },

  // {
  //   menuName: 'Billing',
  //   link: '/billing',
  //   icon: billingMenuIcon,
  // },
  {
    menuName: 'Claims',
    link: PATHS.CLAIMS,
    icon: claimsMenyIcon,
    toShow: ["ADMIN", "STAFF", "MANAGER", "SALES"]
  },
  {
    menuName: 'Ship From',
    link: PATHS.SHIP_FROM,
    icon: shipFromMenuIcon,
    toShow: ["ADMIN", "STAFF", "MANAGER", "SALES"]
  },

  {
    menuName: 'Staff',
    link: PATHS.STAFF,
    icon: staffMenuIcon,
    toShow: ["ADMIN", "STAFF", "MANAGER"]
  },
  {
    menuName: 'Payment',
    link: PATHS.PAYMENT,
    icon: paymentsMenuIcon,
    toShow: ["ADMIN", "STAFF", "MANAGER"]
  },
  {
    menuName: 'Billing',
    link: PATHS.BILLINGS,
    icon: billingIcon,
    toShow: ["ADMIN", "STAFF", "MANAGER"]
  },
  {
    menuName: 'Trade Show',
    link: PATHS.TRADESHOWPOLICY,
    icon: billingIcon,
    toShow: ["ADMIN", "STAFF", "MANAGER", "SALES"]
  },
  {
    menuName: 'LPP',
    link: PATHS.LEASEPROTECTIONPOLICY,
    icon: leaseProtectionIcon,
    toShow: ["ADMIN", "STAFF", "MANAGER", "SALES"]
  },
];
